export function getUrlParamValue(url: string, paramName: string) {
  try {
    const parsedUrl = new URL(url);
    const paramValue = parsedUrl.searchParams.get(paramName);
    return paramValue || null;
  } catch {
    return null;
  }
}
